function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1988(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 26.02,
    height: 12.19,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.3544444444444443
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.01,
    y: 6.095,
    fontFamily: "Arial"
  }, "\n        Menominee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 12.19,
    width: 26.02,
    height: 18.42,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.3025
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.01,
    y: 21.4,
    fontFamily: "Arial"
  }, "\n        Florence\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 30.61,
    width: 26.02,
    height: 27.94,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.204
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.01,
    y: 44.58,
    fontFamily: "Arial"
  }, "\n        Pepin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 58.55,
    width: 26.02,
    height: 31.95,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.505
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.01,
    y: 74.52499999999999,
    fontFamily: "Arial"
  }, "\n        Iron\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 90.5,
    width: 26.02,
    height: 34.48,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.336666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.01,
    y: 107.74,
    fontFamily: "Arial"
  }, "\n        Forest\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 124.98,
    width: 26.02,
    height: 47.88,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.891111111111111
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.01,
    y: 148.92000000000002,
    fontFamily: "Arial"
  }, "\n        Marquette\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 172.86,
    width: 26.02,
    height: 54.3,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.717142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.01,
    y: 200.01000000000002,
    fontFamily: "Arial"
  }, "\n        Buffalo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 227.16,
    width: 26.02,
    height: 55.61,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.717142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.01,
    y: 254.965,
    fontFamily: "Arial"
  }, "\n        Burnett\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 282.77,
    width: 26.02,
    height: 55.96,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.2525
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.01,
    y: 310.75,
    fontFamily: "Arial"
  }, "\n        Washburn\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 338.72,
    width: 26.02,
    height: 56.22,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.336666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.01,
    y: 366.83000000000004,
    fontFamily: "Arial"
  }, "\n        Sawyer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 394.94,
    width: 26.02,
    height: 59.2,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.204
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.01,
    y: 424.54,
    fontFamily: "Arial"
  }, "\n        Adams\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 454.14,
    width: 26.02,
    height: 59.29,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.2525
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.01,
    y: 483.78499999999997,
    fontFamily: "Arial"
  }, "\n        Crawford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 513.43,
    width: 26.02,
    height: 60.24,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.505
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.01,
    y: 543.55,
    fontFamily: "Arial"
  }, "\n        Rusk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 573.67,
    width: 26.02,
    height: 62.19,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.891111111111111
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.01,
    y: 604.765,
    fontFamily: "Arial"
  }, "\n        Lafayette\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 635.85,
    width: 26.02,
    height: 64.15,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.2525
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.01,
    y: 667.9250000000001,
    fontFamily: "Arial"
  }, "\n        Bayfield\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.02,
    y: 0,
    width: 37.66,
    height: 44.46,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.38
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 44.849999999999994,
    y: 22.23,
    fontFamily: "Arial"
  }, "\n        Ashland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 63.69,
    y: 0,
    width: 37.74,
    height: 44.46,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.548
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 82.56,
    y: 22.23,
    fontFamily: "Arial"
  }, "\n        Price\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 101.43,
    y: 0,
    width: 37.84,
    height: 44.46,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.405714285714287
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 120.35000000000001,
    y: 22.23,
    fontFamily: "Arial"
  }, "\n        Jackson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 139.27,
    y: 0,
    width: 38.8,
    height: 44.46,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.85
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 158.67000000000002,
    y: 22.23,
    fontFamily: "Arial"
  }, "\n        Richland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 178.07,
    y: 0,
    width: 40.78,
    height: 44.46,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.796666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 198.45999999999998,
    y: 22.23,
    fontFamily: "Arial"
  }, "\n        Taylor\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 218.85,
    y: 0,
    width: 41.78,
    height: 44.46,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.178
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 239.74,
    y: 22.23,
    fontFamily: "Arial"
  }, "\n        Green_Lake\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 260.62,
    y: 0,
    width: 43.03,
    height: 44.46,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.7575
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 282.135,
    y: 22.23,
    fontFamily: "Arial"
  }, "\n        Iowa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 303.65,
    y: 0,
    width: 43.06,
    height: 44.46,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.3825
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 325.17999999999995,
    y: 22.23,
    fontFamily: "Arial"
  }, "\n        Waushara\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 346.71,
    y: 0,
    width: 43.6,
    height: 44.46,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.266666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 368.51,
    y: 22.23,
    fontFamily: "Arial"
  }, "\n        Juneau\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 390.32,
    y: 0,
    width: 46.21,
    height: 44.46,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.5575
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 413.425,
    y: 22.23,
    fontFamily: "Arial"
  }, "\n        Kewaunee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 436.52,
    y: 0,
    width: 46.24,
    height: 44.46,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.5575
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 459.64,
    y: 22.23,
    fontFamily: "Arial"
  }, "\n        Langlade\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 482.77,
    y: 0,
    width: 48.94,
    height: 44.46,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.892
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 507.24,
    y: 22.23,
    fontFamily: "Arial"
  }, "\n        Vilas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 531.71,
    y: 0,
    width: 55.77,
    height: 44.46,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.41
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 559.595,
    y: 22.23,
    fontFamily: "Arial"
  }, "\n        Vernon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 587.47,
    y: 0,
    width: 56.26,
    height: 44.46,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.041818181818182
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 615.6,
    y: 22.23,
    fontFamily: "Arial"
  }, "\n        Trempealeau\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 643.73,
    y: 0,
    width: 56.27,
    height: 44.46,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.351428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 671.865,
    y: 22.23,
    fontFamily: "Arial"
  }, "\n        Lincoln\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.02,
    y: 44.46,
    width: 53.76,
    height: 49.58,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.916
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.9,
    y: 69.25,
    fontFamily: "Arial"
  }, "\n        Green\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.02,
    y: 94.04,
    width: 53.76,
    height: 51.72,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.93
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.9,
    y: 119.9,
    fontFamily: "Arial"
  }, "\n        Door\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.02,
    y: 145.76,
    width: 53.76,
    height: 54.28,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.751999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.9,
    y: 172.89999999999998,
    fontFamily: "Arial"
  }, "\n        Clark\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.02,
    y: 200.03,
    width: 53.76,
    height: 56.56,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.959999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.9,
    y: 228.31,
    fontFamily: "Arial"
  }, "\n        Monroe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.02,
    y: 256.59,
    width: 53.76,
    height: 57.11,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.959999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.9,
    y: 285.145,
    fontFamily: "Arial"
  }, "\n        Oconto\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.02,
    y: 313.7,
    width: 53.76,
    height: 61.24,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.68
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.9,
    y: 344.32,
    fontFamily: "Arial"
  }, "\n        Calumet\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.02,
    y: 374.94,
    width: 53.76,
    height: 61.57,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.959999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.9,
    y: 405.725,
    fontFamily: "Arial"
  }, "\n        Pierce\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.02,
    y: 436.51,
    width: 53.76,
    height: 62.65,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.68
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.9,
    y: 467.835,
    fontFamily: "Arial"
  }, "\n        Shawano\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.02,
    y: 499.16,
    width: 53.76,
    height: 65.24,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.959999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.9,
    y: 531.78,
    fontFamily: "Arial"
  }, "\n        Oneida\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.02,
    y: 564.4,
    width: 53.76,
    height: 66.51,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.44
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.9,
    y: 597.655,
    fontFamily: "Arial"
  }, "\n        Polk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.02,
    y: 630.91,
    width: 53.76,
    height: 69.09,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.44
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.9,
    y: 665.4549999999999,
    fontFamily: "Arial"
  }, "\n        Dunn\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 79.78,
    y: 44.46,
    width: 62.12,
    height: 63.3,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.353333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 110.84,
    y: 76.11,
    fontFamily: "Arial"
  }, "\n        Barron\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 141.9,
    y: 44.46,
    width: 62.81,
    height: 63.3,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.978888888888889
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 173.305,
    y: 76.11,
    fontFamily: "Arial"
  }, "\n        Marinette\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 204.7,
    y: 44.46,
    width: 66.07,
    height: 63.3,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.825
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 237.73499999999999,
    y: 76.11,
    fontFamily: "Arial"
  }, "\n        Sauk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 270.77,
    y: 44.46,
    width: 66.32,
    height: 63.3,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.042857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 303.92999999999995,
    y: 76.11,
    fontFamily: "Arial"
  }, "\n        Waupaca\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 337.09,
    y: 44.46,
    width: 69.23,
    height: 63.3,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.66
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 371.705,
    y: 76.11,
    fontFamily: "Arial"
  }, "\n        Grant\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 406.32,
    y: 44.46,
    width: 69.76,
    height: 63.3,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.9125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 441.2,
    y: 76.11,
    fontFamily: "Arial"
  }, "\n        Columbia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 476.07,
    y: 44.46,
    width: 72.3,
    height: 63.3,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.042857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 512.22,
    y: 76.11,
    fontFamily: "Arial"
  }, "\n        Douglas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 548.37,
    y: 44.46,
    width: 75.5,
    height: 63.3,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.9125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 586.12,
    y: 76.11,
    fontFamily: "Arial"
  }, "\n        Chippewa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 623.87,
    y: 44.46,
    width: 76.13,
    height: 63.3,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.033333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 661.935,
    y: 76.11,
    fontFamily: "Arial"
  }, "\n        St._Croix\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 79.78,
    y: 107.76,
    width: 83.19,
    height: 70.87,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.874444444444445
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 121.375,
    y: 143.195,
    fontFamily: "Arial"
  }, "\n        Jefferson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 79.78,
    y: 178.63,
    width: 83.19,
    height: 76.77,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.967142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 121.375,
    y: 217.015,
    fontFamily: "Arial"
  }, "\n        Portage\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 79.78,
    y: 255.4,
    width: 83.19,
    height: 80.51,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 16.102
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 121.375,
    y: 295.65500000000003,
    fontFamily: "Arial"
  }, "\n        Dodge\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 79.78,
    y: 335.91,
    width: 83.19,
    height: 82.55,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.31875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 121.375,
    y: 377.185,
    fontFamily: "Arial"
  }, "\n        Walworth\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 79.78,
    y: 418.47,
    width: 83.19,
    height: 88.37,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 20.7975
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 121.375,
    y: 462.65500000000003,
    fontFamily: "Arial"
  }, "\n        Wood\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 79.78,
    y: 506.84,
    width: 83.19,
    height: 96.35,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.884285714285713
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 121.375,
    y: 555.015,
    fontFamily: "Arial"
  }, "\n        Ozaukee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 79.78,
    y: 603.18,
    width: 83.19,
    height: 96.82,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.243333333333332
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 121.375,
    y: 651.5899999999999,
    fontFamily: "Arial"
  }, "\n        Manitowoc\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 162.97,
    y: 107.76,
    width: 79.31,
    height: 107.73,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.21
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 202.625,
    y: 161.625,
    fontFamily: "Arial"
  }, "\n        Fond_du_Lac\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 242.28,
    y: 107.76,
    width: 81.07,
    height: 107.73,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.107
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 282.815,
    y: 161.625,
    fontFamily: "Arial"
  }, "\n        Eau_Claire\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 323.35,
    y: 107.76,
    width: 84.22,
    height: 107.73,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.422
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 365.46000000000004,
    y: 161.625,
    fontFamily: "Arial"
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 407.57,
    y: 107.76,
    width: 91.55,
    height: 107.73,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.172222222222222
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 453.34499999999997,
    y: 161.625,
    fontFamily: "Arial"
  }, "\n        La_Crosse\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 499.11,
    y: 107.76,
    width: 98.01,
    height: 107.73,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.89
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 548.115,
    y: 161.625,
    fontFamily: "Arial"
  }, "\n        Sheboygan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 62,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 597.12,
    y: 107.76,
    width: 102.88,
    height: 107.73,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.86
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 648.56,
    y: 161.625,
    fontFamily: "Arial"
  }, "\n        Marathon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 63,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 162.97,
    y: 215.5,
    width: 108.83,
    height: 107.2,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.314285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 217.385,
    y: 269.1,
    fontFamily: "Arial"
  }, "\n        Kenosha\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 64,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 162.97,
    y: 322.7,
    width: 108.83,
    height: 119.66,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 27.2075
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 217.385,
    y: 382.53,
    fontFamily: "Arial"
  }, "\n        Rock\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 65,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 162.97,
    y: 442.36,
    width: 108.83,
    height: 126.02,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.092222222222222
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 217.385,
    y: 505.37,
    fontFamily: "Arial"
  }, "\n        Outagamie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 66,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 162.97,
    y: 568.37,
    width: 108.83,
    height: 131.63,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.092222222222222
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 217.385,
    y: 634.185,
    fontFamily: "Arial"
  }, "\n        Winnebago\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 67,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 271.8,
    y: 215.5,
    width: 105.35,
    height: 162.8,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 17.558333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 324.475,
    y: 296.9,
    fontFamily: "Arial"
  }, "\n        Racine\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 68,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 377.15,
    y: 215.5,
    width: 118.16,
    height: 162.8,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 23.631999999999998
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 436.22999999999996,
    y: 296.9,
    fontFamily: "Arial"
  }, "\n        Brown\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 69,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 495.31,
    y: 215.5,
    width: 204.69,
    height: 162.8,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 20.35
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 597.655,
    y: 296.9,
    fontFamily: "Arial"
  }, "\n        Waukesha\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 70,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 271.8,
    y: 378.3,
    width: 122.4,
    height: 321.7,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 30.6
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 333,
    y: 539.15,
    fontFamily: "Arial"
  }, "\n        Dane\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 71,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 394.2,
    y: 378.3,
    width: 305.8,
    height: 321.7,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 33.97777777777778
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 547.1,
    y: 539.15,
    fontFamily: "Arial"
  }, "\n        Milwaukee\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1988);
export default __webpack_public_path__ + "static/media/1988.0aa068d76a578daa836ebb4059e8451c.svg";
export { ForwardRef as ReactComponent };